<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">
      <span>{{ pageInfo.isRate==0?'评价订单':'评价详情' }}</span>
      <span class="box_titleText" style="margin-left: auto;">订单号：{{ ordersn}}</span>
      <span class="box_titleText">{{getDate(createTime)  }}</span>
    </div>
    <!-- 总体评价 -->
    <div class="rateBox">
      <div class="rateItem" v-for="(item,index) in rateList" :key="index">
        <span class="rateItem_label">{{ item.label }}</span>
        <div class="scoreBar">
          <div class="scoreBarItem" v-for="(it,ind) in 5" :key="ind" @click="scoring(it,item.field)">
            <img :src="`/static/image/star${pageInfo[item.field]>ind?'_checked':''}.png`" :class="['starImg',pageInfo[item.field]>ind&&isAction&&field==item.field?'starAnimation':'']" :style="{animationDelay: ind*0.1+'s'}" />
          </div>
        </div>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="goodsList" v-for="(item,index) in pageInfo.rateOrderGoods" :key="index">
      <div class="goodsBox">
        <img :src="item.thumb" alt="" class="goodsImg">
        <div class="goodsMain">
          <span class="goodsTitle">{{item.title}}</span>
          <span class="goodsNum">x{{ item.total }}件</span>
          <span class="goodsPrice">¥{{ item.sumPrice.toFixed(2) }}</span>
        </div>
      </div>
      <div class="goodsScoreBox">
        <span class="rateItem_label">商品评价</span>
        <div class="scoreBar">
          <div class="scoreBarItem" v-for="(it,ind) in 5" :key="ind" @click="scoring(it,'rateOrderGoods',index)">
            <img :src="`/static/image/star${item.rateQuality>ind?'_checked':''}.png`" :class="['starImg',item.rateQuality>ind&&isAction&&field=='rateOrderGoods'?'starAnimation':'']" :style="{animationDelay: ind*0.1+'s'}" />
          </div>
        </div>
      </div>
      <div class="goodsContentBox" v-if="pageInfo.isRate==0||item.rateDesc.length>0">
        <span class="rateItem_label">评价晒单</span>
        <el-input :disabled="pageInfo.isRate==1" type="textarea" :rows="5" :maxLength="200" placeholder="请留下对我们商品的宝贵建议（200字以内）" v-model="item.rateDesc" resize="none" style="width: 800px">
        </el-input>
      </div>
      <div class="contentImgBox">
        <!-- <div class="contentImgItem" v-for="(it,ind) in item.images" :key="ind">
          <img :src="it" class="contentImg" />
          <img src="/static/image/close.png" class="contentImg_deleteBtn" @click="handleRemove(index,ind)" v-if="pageInfo.isRate==0" />
        </div> -->
        <el-upload :disabled="pageInfo.isRate==1" :class="{ hideUploadLogo:pageInfo.isRate==1||item.images.length>5 }" :action="baseURL+uploadUrl" list-type="picture-card" :fileList="item.fileList" :on-change="(file, fileList) =>handleChange(file, fileList,index)" :before-upload="beforeUpload" :on-success="(response,file, fileList) =>handleSuccess(response,file, fileList,index)" :on-remove="(file, fileList) => handleRemove(file, fileList, index)" :on-preview="handlePreview" accept=".jpg,.jpeg,.png">
          <div class="uploadBtnBox">
            <img src="/static/image/pic.png" alt="" class="uploadIcon">
            <span class="uploadBtnText">上传图片</span>
            <span class="uploadBtnText">（最多6张）</span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="visible">
          <img width="100%" :src="modalImg" alt="" />
        </el-dialog>
      </div>
    </div>
    <div class="submitBtnBox" v-if="pageInfo.isRate==0">
      <div class="submitBtn" @click="submitEvaluate">发布评价</div>
    </div>
  </div>
</template>
<script>
import {
  doGet,
  baseURL,
  postAction,
  postActionPc,
} from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      ordersn: this.$route.query.ordersn,
      createTime: this.$route.query.createTime,
      pageInfo: {}, //页面数据
      rateList: [
        {
          label: "描述相符",
          field: "rateDesc",
        },
        {
          label: "物流服务",
          field: "rateLogistics",
        },
        {
          label: "服务评价",
          field: "rateSpeed",
        },
      ],
      isAction: false, //是否添加打分动画
      field: "", //当前打分字段
      scoreGoodsIndex: 0, //当前打分商品索引
      baseURL,
      uploadUrl: httpConfig.upload.url,
      visible: false, //预览弹窗显隐
      modalImg: "", //预览的图片
    };
  },
  mounted() {
    this.getPageInfo();
    return;
    let pageInfo = {
      buyerName: "云之捷",
      buyerPhone: "13222723221",
      id: 532643,
      isRate: 0,
      orderPrice: 476,
      ordersn: "HP202308280003145342754",
      platformsn: "494917470270640128",
      rateDesc: 2,
      rateLogistics: 1,
      rateOrderGoods: [
        {
          discountPrice: 0,
          goodsId: 88927,
          images: [],
          orderId: 532643,
          rateDesc: "",
          rateQuality: 0,
          self: 0,
          sku: "smf2022011703",
          sumPrice: 476,
          supplierId: 142,
          thumb:
            "https://agriculture-source.wyouquan.cn/goods/images/b630c13b9865488b96252e4f4473f6f5.jpg",
          title: "【丰县裕稔】苏米丰赐百味鸡精（1KG*10袋，1箱起订）",
          total: 2,
        },
      ],
      rateSpeed: 5,
      supplierId: 142,
      undefined: 3,
    };
    let rateOrderGoods = JSON.parse(JSON.stringify(pageInfo.rateOrderGoods));
    for (let i = 0; i < rateOrderGoods.length; i++) {
      let item = rateOrderGoods[i];
      item.fileList = [];
      for (let j = 0; j < item.images.length; j++) {
        let it = item.images[j];
        item.fileList.push({ uid: j, url: it });
      }
    }
    pageInfo.rateOrderGoods = rateOrderGoods;
    this.pageInfo = pageInfo;
  },
  methods: {
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      time = Number(time);
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y +
        "." +
        M +
        "." +
        d +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    /**
     * 获取评价详情
     */
    getPageInfo() {
      let that = this;
      postActionPc(
        httpConfig.rateUrl.pcGetRateInfoUrl,
        { ordersn: this.ordersn },
        function (res) {
          let pageInfo = JSON.parse(JSON.stringify(res.data));
          let rateOrderGoods = JSON.parse(
            JSON.stringify(res.data.rateOrderGoods)
          );
          for (let i = 0; i < rateOrderGoods.length; i++) {
            let item = rateOrderGoods[i];
            item.fileList = [];
            for (let j = 0; j < item.images.length; j++) {
              let it = item.images[j];
              item.fileList.push({ uid: j, url: it });
            }
          }
          pageInfo.rateOrderGoods = rateOrderGoods;
          that.pageInfo = pageInfo;
        },
        function (res) {}
      );
    },
    /**
     * 打分
     */
    scoring(score, field, index) {
      let pageInfo = this.pageInfo;
      if (pageInfo.isRate == 1) return;
      let that = this;
      if (field == "rateOrderGoods") {
        if (pageInfo[field][index].rateQuality == score) return;
        pageInfo[field][index].rateQuality = score;
      } else {
        if (pageInfo[field] == score) return;
        pageInfo[field] = score;
      }
      this.isAction = false;
      this.field = field;
      this.pageInfo = pageInfo;
      this.scoreGoodsIndex = index;
      this.$nextTick(() => {
        setTimeout(() => {
          that.isAction = true;
        }, 100);
      });
    },
    handleChange(file, fileList, index) {
      // console.log(file);
      // let pageInfo = this.pageInfo;
      // if (file.status == "ready") {
      //   console.log(file);
      //   pageInfo.rateOrderGoods[index].images.push(JSON.parse(file.url));
      //   this.pageInfo = pageInfo;
      // } else if (file.status == "error") {
      // }
    },
    /**
     * 上传文件前检查文件大小
     */
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt500k = file.size / 1024 < 500;

      if (!isJPG) {
        this.$message.error("只能上传jpg/jpeg/png格式文件!");
      }
      if (!isLt500k) {
        this.$message.error("文件大小不能超过500kb!");
      }
      return isJPG && isLt500k;
    },
    /**
     * 上传成功
     */
    handleSuccess(response, file, fileList, index) {
      let pageInfo = this.pageInfo;
      pageInfo.rateOrderGoods[index].images.push(response.data);
      pageInfo.rateOrderGoods[index].fileList.push(file);
      this.pageInfo = pageInfo;
    },
    /**
     * 删除图片
     */
    handleRemove(file, fileList, index) {
      let pageInfo = this.pageInfo;
      let url = file.response.data;
      let images = pageInfo.rateOrderGoods[index].images;
      let imgIndex = 0;
      images.some((item, index) => {
        imgIndex = index;
        return url == item;
      });
      pageInfo.rateOrderGoods[index].images.splice(imgIndex, 1);
      pageInfo.rateOrderGoods[index].fileList = fileList;
      this.pageInfo = pageInfo;
      console.log(url);
      console.log(imgIndex);
    },
    /**
     * 查看大图
     */
    handlePreview(file) {
      this.modalImg = file.url;
      this.visible = true;
    },
    /**
     * 立即发表
     */
    submitEvaluate() {
      let that = this;
      let label = "";
      let isIncomplete = that.rateList.some((item) => {
        label = ` ${item.label} `;
        return that.pageInfo[item.field] == 0;
      });
      if (!isIncomplete) {
        isIncomplete = that.pageInfo.rateOrderGoods.some((item) => {
          label = `商品 ${item.title} `;
          return item.rateQuality == 0;
        });
      }
      if (isIncomplete) {
        this.$message.warning(`请对${label}进行打分`);
        return;
      }
      this.$confirm("确认发表？")
        .then((_) => {
          let rateOrderGoods = that.pageInfo.rateOrderGoods.map((item) => {
            return {
              goodsId: item.goodsId,
              images: item.images,
              rateDesc: item.rateDesc, // 商品建议
              rateQuality: item.rateQuality, // 评价:商品质量 1,2,3,4,5
            };
          });
          let params = {
            ordersn: that.ordersn, // 订单号
            rateDesc: that.pageInfo.rateDesc, // 评价:描述相符 1,2,3,4,5
            rateLogistics: that.pageInfo.rateLogistics, // 评价:物流服务 1,2,3,4,5
            rateSpeed: that.pageInfo.rateSpeed, // 评价:发货速度 1,2,3,4,5
            rateOrderGoods: rateOrderGoods,
          };
          postActionPc(
            httpConfig.rateUrl.pcSaveUrl,
            params,
            function (res) {
              if (res.flag) {
                doGet(
                  httpConfig.rateUrl.updateIsRateUrl,
                  { ordersn: that.ordersn },
                  function (res) {
                    if (res.flag) {
                      that.$message.success("评价成功！");
                      that.$router.go(-1);
                    } else {
                      that.$message.error(res.message);
                    }
                  },
                  function (res) {}
                );
              } else {
                that.$message.error(res.message);
              }
            },
            function (res) {}
          );
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/rateOrder";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/rateOrder.vue